export default {
    bankAccountList: []
};
